module.exports = __webpack_public_path__ + "img/4B4A3A_94A3A4_68766F_988475-256px.2d1a5f3d.png";